module.exports = __webpack_public_path__ + "static/media/shopping-bag-white.7172386d.svg";